export default __webpack_public_path__ + "static/media/archive-file.c3b22d43.svg";